import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { DataService } from 'services/data.service';
import { User } from 'domain-models/User';
import { environment } from '../../environments/environment';

@Injectable()
export class UserInfoService extends DataService<User> {
	constructor(http: Http) {
		super(environment.host + 'UserInfo', http);
	}
}



// WEBPACK FOOTER //
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/services/user-info/user-info.service.ts